import {
  addWeeks,
  endOfISOWeek,
  endOfMonth,
  getDay,
  isSameDay,
  setDay,
  startOfISOWeek,
  startOfMonth,
  subDays,
  subMonths,
  subWeeks,
} from 'date-fns'
import { isEmpty, isNil } from 'shared/lib'
import { formatDateClient } from './formatDate'

const day = getDay(new Date())
const isBeforeFiscalThursday = day >= 1 && day <= 3
const getWeekday = (date: Date, weekday: number) =>
  setDay(date, weekday, { weekStartsOn: 1 })

export const isExist = (
  object?: Record<string, unknown> | unknown[] | string,
) => !isNil(object) && !isEmpty(object)

export const isBlank = (
  object?: Record<string, unknown> | unknown[] | string,
) => isNil(object) || isEmpty(object)
export const thisCalendarWeekRange = [
  startOfISOWeek(new Date()),
  endOfISOWeek(new Date()),
]
export const thisFiscalWeekRange = isBeforeFiscalThursday
  ? [getWeekday(subWeeks(new Date(), 1), 4), getWeekday(new Date(), 3)]
  : [getWeekday(new Date(), 4), getWeekday(addWeeks(new Date(), 1), 3)]

export const lastFiscalWeekRange = isBeforeFiscalThursday
  ? [
      getWeekday(subWeeks(new Date(), 2), 4),
      getWeekday(subWeeks(new Date(), 1), 3),
    ]
  : [getWeekday(subWeeks(new Date(), 1), 4), getWeekday(new Date(), 3)]
export const thisMonthRange = [startOfMonth(new Date()), endOfMonth(new Date())]

export const lastsMonthRange = [
  subMonths(startOfMonth(new Date()), 1),
  subDays(startOfMonth(new Date()), 1),
]
export const isRangesAreSame = (
  firstRange: (Date | string)[],
  secondRange: (Date | string)[],
) =>
  isSameDay(firstRange[0], secondRange[0]) &&
  isSameDay(firstRange[1], secondRange[1])
export const timeToMSK = (timeString: string) =>
  `${formatDateClient(timeString, 'HH:mm')} MSK, ${formatDateClient(timeString)}`
